var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.showLoading)?_c('div',{staticClass:"loading-container"},[_c('van-loading',{attrs:{"type":"spinner","size":"24px"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }